module.exports = __webpack_public_path__ + "img/protelBanner.7cc56e68.jpg";